export default "__VITE_ASSET__xhYlqBOq__"